import { Button, ButtonProps } from '@chakra-ui/react'
import { SessionDetail } from '@features/sessions/components/SessionDetail'
import { createFileRoute, Link, useParams } from '@tanstack/react-router'

// const Breadcrumbs = ({ orgId, projectId, workflowSessionId }) => (
//   <Breadcrumb>
//     <BreadcrumbItem>
//       <BreadcrumbLink as={Link} href={`/o/${orgId}`}>
//         Home
//       </BreadcrumbLink>
//     </BreadcrumbItem>

//     <BreadcrumbItem>
//       <BreadcrumbLink as={Link} href={`/o/${orgId}/projects`}>
//         Projects
//       </BreadcrumbLink>
//     </BreadcrumbItem>

//     <BreadcrumbItem>
//       <BreadcrumbLink as={Link} href={`/o/${orgId}/projects/${projectId}/s`}>
//         Sessions
//       </BreadcrumbLink>
//     </BreadcrumbItem>
//   </Breadcrumb>
// )

const BackButton = (props: ButtonProps) => {
  const { orgId, projectId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/',
  })

  return (
    <Link to={`/o/$orgId/projects/$projectId/s`} params={{ orgId, projectId }}>
      <Button {...props} size="xs">
        Back to sessions
      </Button>
    </Link>
  )
}

const SessionDetailRoute = () => {
  const { workflowSessionId } = useParams({
    from: '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/',
  })
  return (
    <>
      <BackButton />
      <SessionDetail workflowSessionId={workflowSessionId} />
    </>
  )
}

export const Route = createFileRoute(
  '/_auth/o/$orgId/projects/$projectId/s/$workflowSessionId/'
)({
  component: SessionDetailRoute,
  beforeLoad: () => ({ getTitle: () => 'Sessions' }),
  loader: () => ({
    crumb: 'Session Detail',
  }),
})
